import { Component, OnInit } from '@angular/core';
import { EcaadminDashboardService } from '../ecaadmin-dashboard.service';

@Component({
  selector: 'app-ecatutors',
  templateUrl: './ecatutors.component.html',
  styleUrls: ['./ecatutors.component.css']
})
export class EcatutorsComponent implements OnInit {
  tutorList: any[];
  selectedTutor;

  constructor(
    private  adminDashboardService:  EcaadminDashboardService
  ) { }

  ngOnInit(): void {
    this.getTutorList();
  }

  getTutorList(){
    this.adminDashboardService.userList({userType:'TUTOR'}).subscribe((dataResult: any)=>{
     // console.log("tutor List",dataResult);
      this.tutorList = dataResult.list;
    //  console.log(this.tutorList);
      this.selectedTutor = this.tutorList[0];
    })
  }

  onTutorDetails(tutorId: string) {
    console.log(tutorId);
    for (let tutor of this.tutorList) {
      if (tutor._id == tutorId) {
        this.selectedTutor = tutor;
      }
    }
   // console.log(this.selectedTutor);
  }

  onDeleteTutor(userId:string){
    console.log("delete id",userId);
    this.adminDashboardService.deleteUser({userId:userId}).subscribe((dataResult:any)=>{
      this.getTutorList();
    })
  }
}
